import TitleLogo from './png/game_title.png';
// april fool 2023
// import TitleLogo from './png/af2023_game_title.png';
import TitleMea from './png/title_mea.png';
import PorinBoxRed from './png/obj_s_porin.png'
import PorinBoxGreen from './png/obj_s_poporin.png'
import PorinBoxBlue from './png/obj_s_marin.png'
import PorinBoxYellow from './png/obj_s_drops.png'
import CharactorRG from './png/charactor_royal_guard.png'
import CharactorKG from './png/charactor_kagerou.png'
import CharactorSM from './png/charactor_summoner.png'
import SkillPanelRG from './png/skill_icon_royal_guard.png'
import SkillPanelKG from './png/skill_icon_kagerou.png'
import SkillPanelSM from './png/skill_icon_summoner.png'
import SkillAreaRG from './png/skill_area_rg.png'
import SkillAreaKG from './png/skill_area_kg.png'
import SkillAreaSM from './png/skill_area_sm.png'
import ObjectMobElvira from './apng/apng_elvira.png'
import ObjectMobRudo from './apng/apng_rudo.png'
import ObjectMobLola from './apng/apng_lola.png'
import ObjectMobSeohyun from './apng/apng_seohyun.png'
import ObjectMobZilant from './apng/apng_zilant.png'
import ObjectMobGarm from './apng/apng_garm.png'
import ObjectMobNightMare from './apng/apng_nightmare.png'
import ObjectMobGryphon from './apng/apng_gryphon.png'
import ObjectTreasure from './png/object_treasure.png'
import ObjectImmortalClystal from './png/object_immotal.png'
import ObjectImmortalPole from './png/object_immotal2.png'
import ObjectImmortalBed from './png/object_immotal3.png'
import ObjectImmortalTable from './png/object_immotal4.png'
import ObjectImmortalGate from './png/object_immotal5.png'
import ObjectImmortalTomb from './png/object_immotal6.png'
import IconPorinBox from './png/icon_porin_box.png'
import IconSkillTarget from './png/icon_skill.png'
import ScoreCoin from './png/icon_score_coin.png'
import ModalMea01 from './png/dialog_queen_mea_01.png'
import ModalMea02 from './png/dialog_queen_mea_02.png'
import ModalMea03 from './png/dialog_queen_mea_03.png'
import ModalMea04 from './png/dialog_queen_mea_04.png'
import ModalZilant from './png/dialog_zilant.png'
import EffectBreak from './png/break.png';
import TipsImage from './png/tips_image.png';
import StageTipsImage from './png/stage_tips_image.png'
import GameClearImage from './png/game_clear_image.png'
import ResultImage from './png/result_image.png'
import ResultClearImage from './png/result_clear_image.png'

import SoundEnable from './svg/sound_on_icon.svg'
import SoundDisable from './svg/sound_off_icon.svg'
import DamageBg from './svg/damage_bg.svg'
import WeaknessBlue from './apng/apng_weak_blue.png'
import WeaknessRed from './apng/apng_weak_red.png'
import WeaknessGreen from './apng/apng_weak_green.png'
import WeaknessYellow from './apng/apng_weak_yellow.png'

import SeDamage from './wav/damage.wav';
import SePut from './wav/put.wav';
import SePorin from './wav/porin.wav';
import SeSelect from './wav/select.wav';
import SeStageClear from './wav/stageclear.wav';
import SeGameOver from './wav/gameover.wav';
import SeSystem from './wav/system.wav';
import SeTreasure from './wav/treasure.wav';


const ObjectPorinRed = require('./apng/apng_porin.png');
const ObjectPorinGreen = require('./apng/apng_poporin.png');
const ObjectPorinBlue = require('./apng/apng_marin.png');
const ObjectPorinYellow = require('./apng/apng_drops.png');

// 2023 april fool
/*
const ObjectPorinRed = require('./apng/af2023_apng_porin.png');
const ObjectPorinGreen = require('./apng/af2023_apng_poporin.png');
const ObjectPorinBlue = require('./apng/af2023_apng_marin.png');
const ObjectPorinYellow = require('./apng/af2023_apng_drops.png');
*/

export default {
    TitleLogo,
    TitleMea,
    PorinBoxRed,
    PorinBoxGreen,
    PorinBoxBlue,
    PorinBoxYellow,
    ObjectPorinRed,
    ObjectPorinGreen,
    ObjectPorinBlue,
    ObjectPorinYellow,
    CharactorRG,
    CharactorKG,
    CharactorSM,
    SkillPanelRG,
    SkillPanelKG,
    SkillPanelSM,
    SkillAreaRG,
    SkillAreaKG,
    SkillAreaSM,
    ObjectMobElvira,
    ObjectMobRudo,
    ObjectMobLola,
    ObjectMobSeohyun,
    ObjectMobZilant,
    ObjectMobGarm,
    ObjectMobNightMare,
    ObjectMobGryphon,
    ObjectTreasure,
    ObjectImmortalClystal,
    ObjectImmortalPole,
    ObjectImmortalBed,
    ObjectImmortalTable,
    ObjectImmortalGate,
    ObjectImmortalTomb,
    IconPorinBox,
    IconSkillTarget,
    EffectBreak,
    TipsImage,
    StageTipsImage,
    GameClearImage,
    ResultImage,
    ResultClearImage,
    ScoreCoin,
    ModalMea01,
    ModalMea02,
    ModalMea03,
    ModalMea04,
    ModalZilant,
    SoundEnable,
    SoundDisable,
    DamageBg,
    WeaknessBlue,
    WeaknessRed,
    WeaknessGreen,
    WeaknessYellow,
    SeDamage,
    SePut,
    SePorin,
    SeSelect,
    SeStageClear,
    SeGameOver,
    SeSystem,
    SeTreasure
}